import { createReducer } from 'reduxsauce'
import Immutable from 'seamless-immutable'
import Types from '../Actions/Types'

export const INITIAL_STATE = Immutable({
    totalStudent: 0,
    studentList: [],
    studentHeader: {
        "inLimit": 100,
        "inOffset": 0,
        "sortField":"firstname",
        "sortBy":"asc",
        "inSearchString":"",
        "class": "",
        "section": "",
        "ailment": ""
    },
    episodeHeader: {
        "inLimit": 5,
        "inOffset": 0,
        "inSortField": 'modified_time',
        "inSortBy": 'desc',
        "inStudentId": null,
        "inOrganizationId": null,
        "inSearchString": '',
        "inCustomFilter": ''
    },
    episodeList: [],
    episodeTotal: 0,
    clinicStudentHeader: {
        "inLimit": 5,
        "inOffset": 0,
        "inSortField": 'name, class, section',
        "inSortBy": 'desc',
        "inStudentId": null,
        "inOrganizationId": null,
        "inSearchString": '',
        "inCustomFilter": ''
    },
    clinicStudentList: [],
    clinicStudentTotal: 0,
    episodeStats: [],
    pdfContent: {}
}) 

const loadStudentReport = (state, action) => {
    return state.merge({
        pdfContent: action.report    
    })
}

const storeStudentList = (state, action) => {
    return state.merge({
        studentList: action.payload.students,
        totalStudent: action.payload.total,
        studentHeader: action.payload.studentHeader
    })
}

const storeClinicStudentSearch = (state, action) => {
    return state.merge({
        clinicStudentList: action.payload.students,
        clinicStudentTotal: action.payload.total,
        clinicStudentHeader: action.payload.header
    })
}

const storeStudentEpisodeSearch = (state, action) => {
    return state.merge({
        episodeList: action.payload.episodes,
        episodeTotal: action.payload.total,
        episodeHeader: action.payload.header
    })
}

const storeClinicEpisodeStats = (state, action) => {
    return state.merge({
        episodeStats: action.payload.stats,
    })
}

const resetStudent = (state, action) => INITIAL_STATE

const ACTION_HANDLERS = {
    [Types.LOAD_STUDENT_REPORT]: loadStudentReport,
    [Types.STORE_STUDENT_LIST]: storeStudentList,
    [Types.RESET_STUDENT]: resetStudent,
    [Types.STORE_STUDENT_EPISODE_SEARCH]: storeStudentEpisodeSearch,
    [Types.STORE_CLINIC_STUDENT_SEARCH]: storeClinicStudentSearch,
    [Types.STORE_CLINIC_EPISODE_STATS]: storeClinicEpisodeStats
}

export default createReducer(INITIAL_STATE, ACTION_HANDLERS)



// WEBPACK FOOTER //
// ./src/Reducers/StudentReducer.js